import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

function __lookupLocalCache(
    key: string,
    moduleId: string,
    messageBus: SDKMessageBus
): Promise<object> {
    return messageBus
        .sendRequest(
            'getCache',
            Maybe.just<string>(
                JSON.stringify({
                    moduleId,
                    key
                })
            )
        )
        .then(function(cacheObj: object) {
            // return void alerting the cache has been cleared
            return cacheObj;
        });
}

function __setLocalCache(
    key: string,
    data: object,
    moduleId: string,
    messageBus: SDKMessageBus
): Promise<void> {
    return messageBus
        .sendRequest(
            'setCache',
            Maybe.just<string>(
                JSON.stringify({
                    moduleId,
                    key,
                    data
                })
            )
        )
        .then(function() {
            return;
        });
}

export function getTectonCacheSetup(
    messageBus: SDKMessageBus,
    moduleId: string,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('tectonCache')) {
        return;
    }
    return function get(key: string, moduleIdToLookup: string = moduleId): Promise<object> {
        return __lookupLocalCache(key, moduleIdToLookup, messageBus);
    };
}

export function setTectonCacheSetup(
    messageBus: SDKMessageBus,
    moduleId: string,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('tectonCache')) {
        // TODO - will return a function that sets serverside cache
        return;
    }
    return function set(key: string, data: object): Promise<void> {
        return __setLocalCache(key, data, moduleId, messageBus);
    };
}
